import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { certificateCount, certificatePerCourse, courseEarnings, financialReport, trainers, userCourseList } from "../apis/apiHandler";

export const userCourseList_ = createAsyncThunk(
    "users/courseList",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await userCourseList(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const trainerReviews_ = createAsyncThunk(
    "users/trainers",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await trainers(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const courseEarnings_ = createAsyncThunk(
    "course/earnings",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await courseEarnings(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const financialReport_ = createAsyncThunk(
    "course/financial_report",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await financialReport(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const certificateCount_ = createAsyncThunk(
    "certificate/count",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await certificateCount(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const certificatePerCourse_ = createAsyncThunk(
    "certificate/certificate_per_course",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await certificatePerCourse(payload);

            if (response?.code == 200 || response?.code == 404) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    userCourseList: [],
    trainerReviews: [],
    courseEarnings: [],
    financialReport: [],
    certificateCount: [],
    certificatePerCourse: [],
    error: null,
    success: false,
};

const reportSlice = createSlice({
    name: "report",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(userCourseList_.pending, (state) => {
                state.loading = true;
            })
            .addCase(userCourseList_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.userCourseList = payload.data;
            })
            .addCase(userCourseList_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(trainerReviews_.pending, (state) => {
                state.loading = true;
            })
            .addCase(trainerReviews_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.trainerReviews = payload.data;
            })
            .addCase(trainerReviews_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(courseEarnings_.pending, (state) => {
                state.loading = true;
            })
            .addCase(courseEarnings_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.courseEarnings = payload.data;
            })
            .addCase(courseEarnings_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(financialReport_.pending, (state) => {
                state.loading = true;
            })
            .addCase(financialReport_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.financialReport = payload.data;
            })
            .addCase(financialReport_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(certificateCount_.pending, (state) => {
                state.loading = true;
            })
            .addCase(certificateCount_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.certificateCount = payload.data;
            })
            .addCase(certificateCount_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(certificatePerCourse_.pending, (state) => {
                state.loading = true;
            })
            .addCase(certificatePerCourse_.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.certificatePerCourse = payload.data;
            })
            .addCase(certificatePerCourse_.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
    },
});

export default reportSlice.reducer;